// Connects the copied page to Shopify: image paths become theme assets, and prices and variant IDs come from the Shopify products.
(function () {
  "use strict";
  var B = window.GS_BASE, V = window.GS_VARIANTS || {}, C = window.STORE_CONFIG;
  function fix(v) {
    if (typeof v === "string") return /^assets\//.test(v) ? B + "glowstrike-" + v.split("/").pop() : v;
    if (Array.isArray(v)) return v.map(fix);
    if (v && typeof v === "object") Object.keys(v).forEach(function (k) { v[k] = fix(v[k]); });
    return v;
  }
  [C, window.STORE_CONTENT, window.STORE_MEDIA].forEach(fix);
  var dollars = function (c) { return c ? c / 100 : null; };
  C.offers.forEach(function (o) {
    var v = (V.offers || {})[o.title];
    if (!v) { o.soldOut = true; return; }
    o.variantId = v.id; o.price = dollars(v.price); o.compareAt = dollars(v.compareAt); o.soldOut = !v.available;
  });
  C.addons.forEach(function (g) {
    var set = V[g.id] || {}, keys = Object.keys(set), main = set.Standard || set[keys[0]], v = g.variants[0];
    if (main) { v.variantId = main.id; v.price = dollars(main.price); v.compareAt = dollars(main.compareAt); }
    if (set.Included) g.includedVariantId = set.Included.id;
  });
})();
